<div class="auth-wrapper">
    <div class="text-center header-section">
        <h2 class="title">Two-Factor Authentication</h2>
        <p class="subtitle">
            We've sent a One-Time Password to your 
            <strong>{{ isEmailMode ? 'Email' : 'Mobile Number' }}</strong>.
        </p>
    </div>

    <form nz-form (ngSubmit)="verifyOtp()" nzLayout="vertical">
        <div class="form-floating mb-3">
            <input type="text" class="form-control" id="otpCode" placeholder="Enter OTP Code" [(ngModel)]="otpCode" name="otpCode" maxlength="10" autocomplete="one-time-code" required />
            <label for="otpCode">OTP</label>
        </div>
        

        <button nz-button nzType="primary" nzSize="large" nzBlock type="submit" [nzLoading]="isSubmitting"
            [disabled]="!otpCode || otpCode.length < 4" class="submit-btn">Verify Code</button>
    </form>

    <div class="action-links">
        <div class="resend-wrapper">
            <span class="text-primary me-2">Didn't receive the code?</span>
            <button nz-button nzType="default" class="ps-2 pe-2" (click)="resendOtp()" [disabled]="countdown > 0">
                Resend {{ countdown > 0 ? '(' + countdown + 's)' : '' }}
            </button>
        </div>
        
        <nz-divider nzText="OR"></nz-divider>

        <button nz-button nzType="default" nzSize="large" (click)="switchMethod()">
            <i nz-icon [nzType]="isEmailMode ? 'mobile' : 'mail'"></i>
            Switch to {{ isEmailMode ? 'SMS' : 'Email' }} verification
        </button>

        <button nz-button nzType="link" nzBlock class="back-btn" (click)="goBack()">
            <i nz-icon nzType="arrow-left"></i> Back to Login
        </button>
    </div>
</div>